export const tableTradPrefix = 'dynamic_table' as const;
export const tableRowActionsTradPrefix = `${tableTradPrefix}.row_actions` as const;
export const tableColumnTradPrefix = `${tableTradPrefix}.columns` as const;

export const statusTableTradPrefix = `${tableTradPrefix}.status` as const;
export const tableHeaderActionsTradPrefix = `${tableTradPrefix}.header_actions` as const;
export const otherTableTradPrefix = `${tableTradPrefix}.other` as const;
export const badgeTableTradPrefix = `${tableTradPrefix}.badge` as const;
export const tableHeaderAction = `${tableTradPrefix}.header_actions` as const;

export const modalTableTradPrefix = `${tableTradPrefix}.modal` as const;

export const tableModalTradPrefix = {
	descriptions: `${modalTableTradPrefix}.descriptions`,
	titles: `${modalTableTradPrefix}.titles`,
	buttons: `${modalTableTradPrefix}.buttons`,
};

export const tableBaseForm = `${tableTradPrefix}.form` as const;

export const tableFormTradPrefix = {
	labels: `${tableBaseForm}.labels`,
	placeholders: `${tableBaseForm}.placeholders`,
	errors: `${tableBaseForm}.errors`,
	buttons: `${tableBaseForm}.buttons`,
};
